import { render, staticRenderFns } from "./pc-nav.vue?vue&type=template&id=75d495f1&scoped=true"
import script from "./pc-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./pc-nav.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pc-nav.vue?vue&type=style&index=0&id=75d495f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d495f1",
  null
  
)

export default component.exports